<template>
    <td>
        <div class="btn-group" role="group">
            <a :href="downloadUrl" target="_blank" class="btn btn-sm btn-primary" data-bs-toggle="tooltip" title="Download" @click="clearTooltips"><fa-icon icon="file-download" class="fa-w-20" /></a>
            <button v-if="!readonly" type="button" class="btn btn-sm btn-danger" @click="removeClicked" data-bs-toggle="tooltip" title="Remove"><fa-icon icon="times" class="fa-w-20" /></button>
        </div>
    </td>
</template>

<script lang="ts">

import { defineComponent } from "vue";

import { confirmOk, confirmYesNo } from "@/shared/components/common/AlertDialog.vue";
import { ButtonClicked } from "@/shared/enums/ButtonClicked";
import Toast from "@/shared/support/Toast";
import { DataRequest } from "@/shared/support/Data";
import Utility from "@/shared/support/Utility";
import Events from "@/shared/support/Events";
import TooltipSupport from "@/shared/support/Tooltip";

export default defineComponent({
    props: {
        uploadId: { type: Number, required: true },
        uploadFileName: { type: String, required: true },
        apiUrl: { type: String, required: true },
        readonly: { type: Boolean, required: false, default: false },
    },
    computed: {
        downloadUrl(): string {
            return Utility.formatUrl(`/Service/Uploads/GetContentById/${this.uploadId}`, null, this.apiUrl, true);
        },
    },
    methods: {
        removeClicked(): void {
            confirmYesNo(`Are you sure you want to remove upload file "${this.uploadFileName}"?`)
                .then((clicked: ButtonClicked): void => {
                    if (clicked === ButtonClicked.Ok) {
                        this.postRemoveUpload();
                    }
                });
        },
        postRemoveUpload(): void {
            const dr = new DataRequest();
            dr.$delete<boolean>(`/Service/Uploads/${this.uploadId}`)
                .then((result: boolean): void => {
                    if (result) {
                        Toast.success(`Upload file "${this.uploadFileName}" has been removed.`);
                        Events.bubbleEvent(this, "upload-grid-reload", this.uploadId);
                    } else {
                        confirmOk(`An error occurred removing upload file "${this.uploadFileName}".`);
                    }
                }).catch((reason: any): void => {
                    confirmOk(`An error occurred removing upload file "${this.uploadFileName}": ${reason}`);
                });
        },
        clearTooltips(): void {
            TooltipSupport.clearTooltips();
        },
    },
});

</script>
